import { getSupabaseClient } from "../supabase/supabase";
import { dashboardRequestError } from "./client";

export async function referralRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const { data } = await getSupabaseClient().auth.getSession();
  const response = await fetch(`/api/referrals/${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${data.session?.access_token ?? ""}`,
    },
  });
  const text = await response.text();
  let body: unknown = null;
  try {
    body = JSON.parse(text);
  } catch {
    /* Keep an explicit upstream error. */
  }
  if (!response.ok) throw dashboardRequestError(response.status, body, text);
  return body as T;
}

export type ReferralDiagnostics = {
  environment: "stg" | "staging";
  as_of: string;
  days: number;
  feedback: {
    opportunities: number;
    rated: number;
    commented: number;
    unrated: number;
  };
  rewards: {
    states: Record<string, number>;
    notified: number;
    // Rewards on a customer's account whose referrer has not been told yet.
    // Older bots do not send this field.
    granted_without_notice?: number;
  };
  engagement: {
    purpose: string;
    // Which Felix number the contact talks to. A WhatsApp template belongs to
    // one business account, so a purpose can be healthy on one sender and
    // entirely unsendable on another. Optional: older bots do not group by it.
    sender_key?: string | null;
    state: string;
    reason: string | null;
    provider_status: string | null;
    count: number;
  }[];
};

export type CampaignPreview = {
  preview_id: string;
  audience_digest: string;
  eligible: number;
  excluded: Record<string, number>;
  expires_at: string;
  launch_blocker: string | null;
  status: string;
};
